import React, { ChangeEvent } from 'react'
import { SearchFilterProps } from './types'
import Panel from '@sharedComponents/Panel'
import { useTranslation } from 'react-i18next'
import filter from 'lodash/filter'
import includes from 'lodash/includes'
import InputCheckbox from "@sharedComponents/InputCheckbox";

const SearchFilter = (props: SearchFilterProps) => {
    const { t } = useTranslation()

    const onChange = (e: ChangeEvent<HTMLInputElement>, cat: string) => {
        const checked = !!e.target.checked
        let newCheckedCategories = [...props.checkedCategories]
        if (checked) {
            newCheckedCategories.push(cat)
        } else {
            newCheckedCategories = filter(
                newCheckedCategories,
                item => item !== cat
            )
        }
        props.doFilter(newCheckedCategories)
    }

    return (
        <div className="search-filter">
            <Panel type="info">
                <div className="search-filter__filter-content">
                    <div className="search-filter__checkboxes">
                        {props.categories.map(cat => {
                            return (
                                <div
                                    key={`search-filter-checkbox-${cat}`}
                                    className="search-filter__checkbox-wrapper"
                                >
                                    <InputCheckbox
                                        id={`search-filter-checkbox-${cat}`}
                                        checked={
                                            !!includes(
                                                props.checkedCategories,
                                                cat
                                            )
                                        }
                                        label={t(`search.category.${cat}`)}
                                        onChange={(
                                            e: ChangeEvent<HTMLInputElement>
                                        ) => onChange(e, cat)}
                                    />
                                </div>
                            )
                        })}
                    </div>
                    <div className="search-filter__results-count">
                        {t('search.resultsWithCount', {
                            count: props.resultsCount,
                        })}
                    </div>
                </div>
            </Panel>
        </div>
    )
}

export default SearchFilter
